import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ReplaySubject, Subscription } from "rxjs";

@Component({
    selector: "app-autocomplete-search",
    templateUrl: "./autocomplete-search.component.html",
    styleUrls: ["./autocomplete-search.component.scss"],
})
export class AutocompleteSearchComponent implements OnInit, OnDestroy {
    @Input() public placeholder = "";
    @Input() public values: string[] = [];
    @Input() public resetSearchBox$?: ReplaySubject<string[] | undefined>;
    @Input() public inMultiSelect = false;
    @Input() public isInFilter = false;

    @Output() public autocompleteOnChange = new EventEmitter<string[]>();

    public searchedValue = "";

    public width = "calc(100% - 2px)";
    public marginLeft = "0px";

    private _resetSearchBoxSubscription$?: Subscription;
    private _isFocused = false;

    @HostListener("document:keydown.escape", ["$event.target"])
    public onClick() {
        if (this._isFocused) {
            this.clearSearch();
        }
    }

    ngOnInit(): void {
        this._resetSearchBoxSubscription$ = this.resetSearchBox$?.subscribe(() => {
            this.searchedValue = "";
        });
        this._setCustomCss();
    }

    ngOnDestroy(): void {
        this._resetSearchBoxSubscription$?.unsubscribe();
    }

    public onChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        const upperLetter = value.toUpperCase();

        if (!value || value === "") {
            this.autocompleteOnChange.emit(this.values);
        }

        const newList = this.values.filter((name) => name.toUpperCase().includes(upperLetter));

        this.autocompleteOnChange.emit(newList);
    }

    public clearSearch(newValues?: string[]) {
        this.searchedValue = "";
        this.values = newValues || this.values;
        this.autocompleteOnChange.emit(this.values);
    }

    public onFocus(event: unknown | undefined) {
        if (event) {
            this._isFocused = true;
        } else {
            this._isFocused = false;
        }
    }

    private _setCustomCss() {
        if (this.isInFilter) {
            this.width = "calc(100% - 34px)";
            this.marginLeft = "16px";
        }
    }
}
